import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useParams } from "react-router-dom";

import Button from "../components/Button/Button.js";

import { getFirstName } from "../util/methods.js";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const setGameState = useStore((state) => state.setGameState);
  const isHost = useStore((state) => state.isHost);
  const gameState = useStore((state) => state.gameState);
  const character = useStore((state) => state.character);
  // const openHint = useStore((state) => state.openHint);
  const currentHint = useStore((state) => state.currentHint);
  const revealNextHint = useStore((state) => state.revealNextHint);
  const navigateTo = useNavigateWithVars();

  const { roundid } = useParams();

  console.log(
    "Reveal Page",
    "M: " + character?.attributes?.IsMurderer,
    character,
    game,
    currentHint,
    gameState,
  );

  const getMurderer = () => {
    if (getLocalized("game", "Characters")?.data) {
      const murderer = getLocalized("game", "Characters")?.data.find(
        (c) => c.attributes.IsMurderer,
      ).attributes?.Name;
      console.log("The Murderer is", murderer);
      return murderer;
    }
    return null;
  };

  if (!game) return null;
  return (
    <div className={`Page${props.className ? " " + props.className : ""}`}>
      <h1>{getLocalized("texts", "Aufloesung")}</h1>

      {gameState === game?.Rounds + 1 && isHost && (
        <div className="AufloesungBlock">
          <h3>{getLocalized("game", "Aufloesung")?.AudioHeadline}</h3>
          {getLocalized("game", "Aufloesung")?.Audio?.data && (
            <AudioPlayer
              url={
                process.env.REACT_APP_CMS_URL +
                getLocalized("game", "Aufloesung")?.Audio.data?.attributes?.url
              }
              transcript={getLocalized("game", "Aufloesung")?.AudioText || null}
            />
          )}
        </div>
      )}

      {gameState === game?.Rounds + 2 && (
        /* character.attributes.isMurderer && */
        <>
          <br />
          <BlocksRenderer content={character?.AufloesungsText} />

          {/* {!character.IsMurderer && (
            <>
              <BlocksRenderer content={getLocalized("texts", "MurdererIs")} />
              <h3>
                <strong>{getMurderer()}</strong>
              </h3>
            </>
          )} */}
        </>
      )}

      {gameState === game?.Rounds + 2 && (
        <Button onClick={() => navigateTo("/outro")}>
          <strong> {getLocalized("texts", "OutroButtonText")}</strong>
        </Button>
      )}

      {isHost && gameState === game?.Rounds + 1 && (
        <Button onClick={() => setGameState(gameState + 1)}>
          <BlocksRenderer content={getLocalized("texts", "MoerderButton")} />
        </Button>
      )}
    </div>
  );
};

export default Page;
